'use client'
import { FC, useMemo } from 'react'
import { useCustomCart } from '#/src/custom/cart/useCustomCart'
import { StoreDTO } from 'ecosystem'
import { CheckoutPageStd, CheckoutStdPageConfig } from 'storefront-modules/checkout'
import { defaultImage } from '#/src/images'
import { useAppConfigContext } from '#/src/appConfig'

interface CheckoutPageComponentProps {
  store: StoreDTO
  initialData?: CheckoutStdPageConfig['initialData']
}

const CheckoutPageComponent: FC<CheckoutPageComponentProps> = ({ store, initialData }) => {
  const appConfig = useAppConfigContext()
  const cart = useCustomCart({ registerViewCartEvent: true })

  const config: CheckoutStdPageConfig = useMemo(() => {
    return {
      storeId: store.id,
      deliveryOptions: store.deliveries || [],
      pickupOptions: store.pickups || [],
      services: store.services || [],
      shippingConfig: appConfig.shippingProviderConfig,
      paymentProviderConfig: appConfig.paymentProviderConfig,
      cartTotalDiscount: cart.cartTotalDiscount,
      defaultCartImage: defaultImage,
      onApplyDiscountCode: cart.handleApplyDiscountCode,
      onAddToCart: cart.handleAddToCart,
      onRemoveFromCart: cart.handleRemoveFromCart,
      onRemoveDiscountCode: cart.handleRemoveDiscountCode,
      paths: {
        getDiscountCode: '/api/orders/get-discount-code',
        createOrder: '/api/orders/create-order',
        updateOrder: '/api/orders/update-order',
        updateDefaultShipment: '/api/orders/update-default-shipment',
        createInvoiceOrder: '/api/orders/invoice-create',
        updateInvoiceOrder: '/api/orders/invoice-update',
        submitInvoiceOrder: '/api/orders/invoice-submit'
      },
      onCheckout: cart.handleCheckout,
      onPurchase: cart.handlePurchase,
      initialData
    }
  }, [
    store.id,
    store.deliveries,
    store.pickups,
    store.services,
    appConfig.shippingProviderConfig,
    appConfig.paymentProviderConfig,
    cart.cartTotalDiscount,
    cart.handleApplyDiscountCode,
    cart.handleAddToCart,
    cart.handleRemoveFromCart,
    cart.handleRemoveDiscountCode,
    cart.handleCheckout,
    cart.handlePurchase,
    initialData
  ])

  return <CheckoutPageStd {...{ config }} />
}

export default CheckoutPageComponent
